var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(Object.assign({}, {backgroundImage: ("url(" + (_vm.options.img) + ")")}, _vm.options.style))})}
var staticRenderFns = []

export { render, staticRenderFns }